import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/layout/Header'
import Footer from './components/layout/Footer'
import HeroSection from './components/sections/HeroSection'
import ProductShowcase from './components/sections/ProductShowcase'
import ModelShowcase from './components/sections/ModelShowcase'
import Editorial from './components/sections/Editorial'
import FeatureCards from './components/sections/FeatureCards'
import SocialProof from './components/sections/SocialProof'
import ProductPage from './pages/ProductPage'
import CartPage from './pages/CartPage'
import CheckoutPage from './pages/CheckoutPage'

// Home page component
function HomePage() {
  return (
    <>
      <HeroSection />
      <ProductShowcase />
      <ModelShowcase />
      <Editorial />
      <FeatureCards />
      <SocialProof />
    </>
  )
}

function App() {
  return (
    <Router>
      <div className="relative min-h-screen bg-bg-primary">
        {/* Header */}
        <Header />

        {/* Main Content */}
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/product/:id" element={<ProductPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </Router>
  )
}

export default App
